import moment from "moment";
import template from "./bDialogCard.html";
import { MonthPicker } from './fields/MonthPicker/MonthPicker';

export function bDialogCardDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: bDialogCardController,
    controllerAs: 'bDialogCard',
    bindToController: true,
    scope: {
      show: "=",
      name: "=",
      dialogTitle: "=",
      values: "=",
      data: "=",
      select: "=?",
      state: "=",
      func: "&",
      refresh: "=?",
      tab: "=?",
      width: "=?",
      warnings: "=?",
      checkSelectFunc: "&",
      formInvalid: "&",
      validationErrorMessage: "=",
      onSelectChange: "&",
      close: "&?"
    },
    transclude: true
  };

  return directive;
}

class bDialogCardController {
  constructor($routeParams, $interval, $scope, $translate, Admin, Notes, Bundle) {
    'ngInject';

    this.$routeParams = $routeParams;
    this.$translate = $translate;

    this.Admin = Admin;
    this.Notes = Notes;
    this.Bundle = Bundle;
    this.bundleName = Bundle.getBundleType();
    this.$scope = $scope;
    this.$scope.archivedAtIsUndefined = (item) => {
      return item.archivedAt === undefined;
    };

    this.MonthPicker = MonthPicker;

    var timeout = $interval(() => {
      this.notes = Notes.getNotes();
    }, 50);
    $scope.$on("$destroy", () => {
      $interval.cancel(timeout);
      clearTimeout(this.updateHoursFunction);
    });
  }

  underscoreString(string) {
    return string.split(/(?=[A-Z])/).join("_").toUpperCase();
  }

  isWorkNorm(key, norm) {
    const workNorm = ["Worknorm", this.$translate.instant("POSITION.WORKNORM")];
    const hourlyNorm = ["Hourly", this.$translate.instant("POSITION.HOURLYNORM")];
    if((key === 'standardWorkingHours' || key === 'hourlyWorkingHours') && norm === "Long Term Leave"){
      return false;
    }
    if (key === 'hourlyWorkingHours' && workNorm.includes(norm)) {
      return false;
    }
    if (key === 'standardWorkingHours' && hourlyNorm.includes(norm)) {
      return false;
    }
    if ((key === 'standardWorkingHours' || key === 'hourlyWorkingHours') && norm === undefined) {
      return false;
    } else return true;
  }

  isHourlyNorm(key, norm) {
    const monthKeys = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
    const hourlyNorm = ["Hourly", this.$translate.instant("POSITION.HOURLYNORM")];
    const LongTermLeave = ["Long Term Leave",this.$translate.instant("POSITION.LONGTERMLEAVE")];

    return hourlyNorm.includes(norm) || LongTermLeave.includes(norm) ? !monthKeys.includes(key.toString()) : true;
  }

  checkSelect(data, key) {
    if(this.checkSelectFunc) {
      this.checkSelectFunc({isEmployee: {key: key, value: this.values[key]}});
    }
  }

  translateTxt(label) {
    if (label === "Hourly") {
      return this.$translate.instant("POSITION.HOURLYNORM");
    }
    if (label === "Worknorm") {
      return this.$translate.instant("POSITION.WORKNORM");
    }
    if (label === "Long Term Leave") {
      return this.$translate.instant("POSITION.LONGTERMLEAVE");
    }
    return label;
  }

  changeAllRequirements(id, requirement, value) {
    var obj = {};
    obj[requirement] = value;

    var confirmed = confirm(this.$translate.instant("DIALOG_CARD.CONFIRMATION_TEXT"));

    if (confirmed) {
      this.Admin.changeProcessRequirements(this.$routeParams.processId, id, obj).then(
        (/*success*/) => {
          this.refresh = true;
        },
        (error) => {
          this.Notes.postNote({type: "error", error: error});
        }
      );
    }
  }

  checkCheckbox(data, checkedKey) {
    if(checkedKey === "restrictedClientAccess") {
      this.data.canImportIncome.editionDisabled = this.values.restrictedClientAccess;
      if(this.values.restrictedClientAccess) {
        this.values.canImportIncome = false;
        this.values.canImportIncomeCountrywide = false;
      }
    }

    Object.keys(data).map(key => {
      if (data[key].reliantOn && data[key].reliantOn === "any") {
        data['directOClogin'].editionDisabled = !(this.values['calcClientDataAccess'] === true ||
          this.values['calcGlobalBidsAccess'] === true ||
          this.values['calcOfferBuilderAccess'] === true ||
          this.values['calcPgEditAccess'] === true ||
          this.values['calcPgViewAccess'] === true ||
          this.values['calcTemplatesAccess'] === true ||
          this.values['calcTemplatesEditAccess'] === true) ? true : false;
      }
      if (data[key].reliantOn && data[key].reliantOn == checkedKey && !data[key].clearDisabled) {
        if (this.values[checkedKey] == false) {
          this.values[key] = typeof this.values[key] === 'boolean' ? false : null;
        }
      }

      if (
        key === 'directOClogin'
        && !this.values['calcClientDataAccess']
        && !this.values['calcTemplatesAccess']
        && !this.values['calcOfferBuilderAccess']
      ) {
        this.values[key] = false;
      }
    });
  }

  bundleReturnDialogCard(key) {
    if (this.bundleName === 'roedl') return true;
    if (this.bundleName === 'basic') {
      const basicKeys = [
        "CASEmanInterfaceConfiguration",
        "CASEmanIncomeImport",
        "FlexibleWorknormManagement",
        "Flexitime",
        "ManagementView",
        "VacationReporting",
        "OfferCalculator"];
      return !basicKeys.includes(key);
    }
    if (this.bundleName === 'business') {
      const basicKeys = [
        "CASEmanInterfaceConfiguration",
        "CASEmanIncomeImport",
        "OfferCalculator"
      ];
      return !basicKeys.includes(key);
    }
    if (this.bundleName === 'enterprise') {
      const basicKeys = [
        "CASEmanInterfaceConfiguration",
        "CASEmanIncomeImport"];
      return !basicKeys.includes(key);
    }
  }

  checkRadio(data, checked) {
    let radio = [];
    Object.keys(data).forEach(key => {
      if (data[key].type == 'radio') {
        radio.push(key);
      }
    });

    radio.forEach(r => {
      if (r != checked) {
        this.values[r] = false;
      }
    });
  }

  addValueToToDoList(key) {
    const valueKey = key + 'Value';
    this.values[key].push(this.values[valueKey]);
    this.values[valueKey] = null;
  }

  deleteValueFromToDoList(key, index) {
    this.values[key] = this.values[key].filter((_, ind) => index !== ind);
  }

  validation() {
    if (!this.formInvalid)
      return false;

    return this.formInvalid({values: this.values});
  }

  formatNumberToTime(hours) {
    const formattedHours = hours.replaceAll(',', '.');
    const duration = moment.duration(formattedHours, 'hours');

    const timePart = (timePart) => {
      return timePart < 10 ? `0${timePart}` : timePart;
    };

    return `${timePart(duration.get('hours'))}:${timePart(duration.get('minutes'))}:${timePart(duration.get('seconds'))}`;
  }

  validateHour(key) {
    const hour = this.values[key];

    if ((!hour || hour.length === 0) && this.values[key + 'Error']) {
      delete this.values[key + 'Error'];
      return;
    }

    clearTimeout(this.updateHoursFunction);
    this.updateHoursFunction = setTimeout(() => {
      const numberFormat = /^(\d*([,.]\d*)|\d*)$/;
      const format = /^(\d+:[0-5]\d:[0-5]\d|\d*([,.]\d*)|\d*)$/;
      const match = hour.match(format);

      if (!match) {
        this.values[key + 'Error'] = true;
      }
      else {
        if (this.values[key + 'Error'])
          delete this.values[key + 'Error'];

        if (hour.match(numberFormat))
          this.values[key] = this.formatNumberToTime(this.values[key]);
      }
    }, 700);
  }

  toggleAll(key) {
    if (this.select[key].allSelected)
      this.values[key] = this.select[key].values;
    else
      this.values[key] = [];
  }

  monthChanged() {
    return (key, date) => {
      this.values[key] = moment(date).format("YYYY-MM");
    };
  }

  searchHandler(key) {
    return (value) => {
      return this.data[key].searchFn(value);
    };
  }

  setClientFromMdp(key) {
    return (client) => {
      return this.data[key].setClientFromMdp(client);
    };
  }

  closeModal() {
    if (this.close)
      this.close();
    else
      this.show = false;
  }
}
